import { Aside, AsideType } from '@squareup/dex-ui';
import React, { FC, PropsWithChildren } from 'react';

function createCallout(asideType: AsideType): FC<PropsWithChildren> {
  const Callout: FC<PropsWithChildren> = ({ children }) => {
    return <Aside type={asideType}>{children}</Aside>;
  };
  Callout.displayName = `MdxCallout.${
    asideType.charAt(0).toUpperCase() + asideType.slice(1)
  }`;
  return Callout;
}

// Mapping rationale: match how Contentful renders these Fern tags so the
// MDX render matches the existing prod chrome.
//   - `<Warning>` is the docs convention for "caution / heads up", which
//     Contentful styles as the yellow `Important` callout (header text
//     "Important"). dex-ui's `warning` AsideType is the red error variant
//     instead, so we route Warning → `important` to keep the visual
//     parity with Contentful.
//   - `<Info>` and `<Note>` both render as the neutral `info` AsideType
//     ("Note" header).
const Info = createCallout('info');
const Warning = createCallout('important');
const Tip = createCallout('tip');
const Note = createCallout('info');
const Success = createCallout('success');

const MdxCallout = { Info, Warning, Tip, Note, Success };

export { MdxCallout };
